import { render, staticRenderFns } from "./FormItemExamConfig.vue?vue&type=template&id=dc06e57c&scoped=true&"
import script from "./FormItemExamConfig.vue?vue&type=script&lang=js&"
export * from "./FormItemExamConfig.vue?vue&type=script&lang=js&"
import style0 from "./FormItemExamConfig.vue?vue&type=style&index=0&id=dc06e57c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc06e57c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc06e57c')) {
      api.createRecord('dc06e57c', component.options)
    } else {
      api.reload('dc06e57c', component.options)
    }
    module.hot.accept("./FormItemExamConfig.vue?vue&type=template&id=dc06e57c&scoped=true&", function () {
      api.rerender('dc06e57c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/FormItemExamConfig.vue"
export default component.exports